import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { useWindowScroll } from 'react-use';
import styles from './_scrollTopBottom.module.scss';

function ScrollTopBottom() {
  const windowScroll = useWindowScroll();
  const { y: pageYOffset } = windowScroll || {};
  const [isDisplayScrollIcon, setIsDisplayScrollIcon] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      updateDimensions();
    }, 500);
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, [pageYOffset]);

  const updateDimensions = () => {
    setIsDisplayScrollIcon(
      document.documentElement.scrollHeight > window.innerHeight + 100 && window.innerWidth < 991,
    );
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToDown = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  };

  const isUpIcon = pageYOffset < 100;
  return (
    <div>
      <div
        className={cx(styles['scroll-top-bottom-box'], {
          [styles['scroll-top-bottom']]: isDisplayScrollIcon,
        })}
      >
        <div onClick={() => (isUpIcon ? scrollToDown() : scrollToTop())}>
          <img
            src="/images/up-down.svg"
            alt="up-down"
            className={cx(styles['up-down-icon'], {
              [styles['down-icon']]: isUpIcon,
              [styles['down-icon-transition']]: isDisplayScrollIcon,
            })}
          />
        </div>
      </div>
    </div>
  );
}

export default ScrollTopBottom;
